import { styled } from '@mui/material/styles';
import { PAGE_Z_INDEX } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/components/StyledComponents';

import IconButton from '@mui/material/IconButton';

export const StatementGridRoot = styled('div', { label: 'StatementGridRoot' })(() => ({
  position: 'absolute',
  inset: 0,
  zIndex: PAGE_Z_INDEX.STATEMENT_GRID,
}));

export const StatementGridAction = styled(IconButton, { label: 'StatementGridAction' })(() => ({
  zIndex: 3,
  position: 'absolute',
  width: 18,
  height: 18,
  padding: 2,
}));
